import React, { FunctionComponent } from 'react';
import { RootState } from '../../app/store';
import { ConnectedProps, connect } from 'react-redux';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import QuestionnairesDetail from './QuestionnairesDetail/QuestionnairesDetail.container';
import QuestionnairesList from './QuestionnairesList/QuestionnairesList.container';
import { Wrap } from '../../assets/styledAssets/grid';
import QuestionnaireEdit from './components/QuestionnaireEdit/QuestionnaireEdit.component';

const connector = connect((state: RootState) => ({}), {});

type PropsFromRedux = ConnectedProps<typeof connector>;

const Questionnaires: FunctionComponent<PropsFromRedux> = () => {
  const { url, path } = useRouteMatch();
  return (
    <Wrap flexDir={'column'} flexWrap={'nowrap'} width={'100%'} overflow={'auto'}>
      <Switch>
        <Route
          exact
          path={`${path}`}
          render={() => <QuestionnairesList url={url} />}
        />
        <Route
          exact
          path={`${path}/send/:questionId/:languageId`}
          render={() => <QuestionnairesDetail />}
        />
        <Route
          exact
          path={`${path}/edit/:questionId/:languageId`}
          render={() => <QuestionnaireEdit />}
        />
      </Switch>
    </Wrap>
  );
};

export default connector(Questionnaires);
